import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import {
  greyMui,
  MOBILE_BREAKPOINT,
  rydeColors,
  ScreenDepth,
} from "@ryde/theme";

export const StarredToggleWrapper = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "starred-toggle",
})`
  .starred-popper {
    z-index: ${ScreenDepth.FLOATING_MENU};
  }

  .starred-icon__container {
    width: 18px;
    height: 18px;
    cursor: pointer;
    vertical-align: middle;
    line-height: 1px;
  }

  .starred-dropdown {
    button.MuiButtonGroup-firstButton {
      padding-inline: 6px;
      min-width: 65px;
      gap: 5px;
      &:hover {
        border-inline-end-color: ${greyMui._100};
      }
    }

    .MuiButtonGroup-grouped {
      border-color: ${greyMui._300};
      color: ${rydeColors.black};
      gap: 8px;
    }

    &:hover {
      background-color: ${rydeColors.focusedOption};
    }

    .starred-group-button.MuiButtonGroup-lastButton.MuiButtonGroup-grouped {
      min-width: 20px;
      padding-inline: 3px;
    }

    .arrow-button {
      padding: 0;
      color: ${greyMui._500};
    }

    @media (max-width: ${MOBILE_BREAKPOINT}) {
      button.MuiButtonGroup-firstButton {
        min-width: 0;
        padding-inline: 4px;
        gap: 2px;
      }

      .starred-group-button.MuiButtonGroup-lastButton.MuiButtonGroup-grouped {
        min-width: 24px;
        padding-inline: 0;
      }
    }
  }

  .user-updated-icon {
    margin-inline-start: -2px;
    font-size: 20px;
    &.grey {
      color: ${greyMui._600};
    }
  }

  .user-icon-replacement {
    width: 22px;
    height: 22px;
  }
`;
